import { useTranslation } from "react-i18next";
import { Alert } from "@/components/ui";
import type { SettlementRevolutPayoutResponse } from "@/services/adminSettlementService";

export function SettlementRevolutBanner({ payout }: { payout: SettlementRevolutPayoutResponse }) {
  const { t } = useTranslation("payments");

  return (
    <Alert
      variant="warning"
      className="shadow-xs"
      title={t("settlements.detail.revolut.bannerTitle")}
    >
      <div className="space-y-1">
        <p>
          {t("settlements.detail.revolut.status", {
            status:
              payout.status === "PENDING_RECONCILIATION"
                ? t("settlements.detail.revolut.pendingReconciliationLabel")
                : payout.status,
          })}
        </p>
        {payout.instructions ? <p>{payout.instructions}</p> : null}
        {payout.failure_reason ? (
          <p className="text-error-800">{payout.failure_reason}</p>
        ) : null}
      </div>
    </Alert>
  );
}
